import logo from './assets/logo.png';

const companyConfig = {
  appName: 'Compass',
  appIcon: 'compass',
  logo: logo,
};

export default companyConfig;
